import API from "../api/manager";
import config from "../api/config";

const login = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.login,
      data,
    },
    false
  );
};

const profile = () => {
  return API({
    method: "GET",
    url: config.urls.auth.profile,
  });
};

const changePassword = (data) => {
  return API({
    method: "PUT",
    url: config.urls.auth.change_password,
    data,
  });
};

export default {
  login,
  profile,
  changePassword,
};
